<template>
  <autocomplete-multiple name="Отделение" :items="items" :select.sync="localSelect" @load="load" :loading="loadState.isLoading">
    <template v-slot:itemInfo="{item}">
      <div class="caption">
        <v-row no-gutters align-content="center">
          <v-col cols="auto"><v-avatar :color="item.comBranch.color" size="10" class="mr-1" style="margin-top:-3px"/></v-col>
          <v-col>{{item.comBranch.name}}</v-col>
        </v-row>
      </div>
    </template>
    <template v-slot:selectedInfo="{item}">
      <v-avatar :color="item.comBranch.color" size="10" class="mr-1" style="margin-top:-2px"/> {{item.comBranch.name}} / {{item.name}}
    </template>
  </autocomplete-multiple>
</template>

<script>
import State from "@/plugins/state";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import {
  Entity_ComDiv,
  Entity_ComBranch,
} from "../../../EntityStoreCacheService";


export default {
  components: {AutocompleteMultiple},
  props:[
    'select'
  ],
  data:()=>({
    loadState: new State(),
    items:[],
    localSelect:null
  }),
  watch:{
    select(){
      if (Array.isArray(this.select) ? this.select.length > 0 : !!this.select) // для сохраненных фильтров
         this.load();

      this.localSelect = this.select;
    },
    localSelect(){
      this.$emit('update:select', this.localSelect)
    }
  },
  mounted() {
    this.localSelect = this.select;
  },
  methods: {
    load() {
      new Entity_ComDiv()
      .selects(Entity_ComDiv.id)
      .selects(Entity_ComDiv.name)
      .selects([Entity_ComDiv.comBranch, Entity_ComBranch.id].join('.'))
      .selects([Entity_ComDiv.comBranch, Entity_ComBranch.name].join('.'))
      .selects([Entity_ComDiv.comBranch, Entity_ComBranch.color].join('.'))
      .order([Entity_ComDiv.comBranch, Entity_ComBranch.id].join('.'), true)
      .page(null)
      .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
      .request((v)=>{
          this.items = v.items;
      }, (e)=>{
        console.error(e.response.data.message);
      }) 
    }
  }
}
</script>